var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading",style:(_vm.loadingStyle)},[_c('img',{staticClass:"l-gif",attrs:{"src":"https://cdnvue.gymcity.com.cn/uploads/loading-member","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }